import { defineComponent as p, openBlock as t, createElementBlock as a, mergeProps as u, unref as o, renderSlot as m, createElementVNode as e, createCommentVNode as g } from "vue";
import { useScalarIcon as h } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, f = { key: 1 }, M = { key: 2 }, k = { key: 3 }, w = { key: 4 }, y = { key: 5 }, _ = {
  name: "ScalarIconDiamond"
}, v = /* @__PURE__ */ p({
  ..._,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = h(s);
    return (i, l) => (t(), a("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(d)), [
      m(i.$slots, "default"),
      o(n) === "bold" ? (t(), a("g", Z, l[0] || (l[0] = [
        e("path", { d: "M238.16,113.89,142.1,17.83a20,20,0,0,0-28.21,0l-96,96.06a20,20,0,0,0,0,28.22l96.05,96.06h0a20,20,0,0,0,28.21,0l96-96.06a20,20,0,0,0,0-28.22ZM128,218.33,37.68,128,128,37.67,218.32,128Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), a("g", f, l[1] || (l[1] = [
        e("path", {
          d: "M229.67,133.62l-96,96a7.94,7.94,0,0,1-11.24,0l-96-96a7.94,7.94,0,0,1,0-11.24l96.05-96a7.94,7.94,0,0,1,11.24,0l96,96.05A7.94,7.94,0,0,1,229.67,133.62Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M235.33,116.72,139.28,20.66a16,16,0,0,0-22.56,0l-96,96.06a16,16,0,0,0,0,22.56l96.05,96.06h0a16,16,0,0,0,22.56,0l96.05-96.06a16,16,0,0,0,0-22.56ZM128,224h0L32,128,128,32,224,128Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), a("g", M, l[2] || (l[2] = [
        e("path", { d: "M240,128a15.85,15.85,0,0,1-4.67,11.28l-96.05,96.06a16,16,0,0,1-22.56,0h0l-96-96.06a16,16,0,0,1,0-22.56l96.05-96.06a16,16,0,0,1,22.56,0l96.05,96.06A15.85,15.85,0,0,1,240,128Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), a("g", k, l[3] || (l[3] = [
        e("path", { d: "M233.92,118.14,137.86,22.08a14,14,0,0,0-19.72,0L22.08,118.14a14,14,0,0,0,0,19.72l96.06,96.06h0a14,14,0,0,0,19.72,0l96-96.06a13.94,13.94,0,0,0,0-19.72Zm-8.49,11.24-96.05,96.06a2,2,0,0,1-2.76,0L30.57,129.38a2,2,0,0,1,0-2.76l96.05-96.06a2,2,0,0,1,2.76,0l96.05,96.06a2,2,0,0,1,0,2.76Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), a("g", w, l[4] || (l[4] = [
        e("path", { d: "M235.33,116.72,139.28,20.66a16,16,0,0,0-22.56,0l-96,96.06a16,16,0,0,0,0,22.56l96.05,96.06h0a16,16,0,0,0,22.56,0l96.05-96.06a16,16,0,0,0,0-22.56ZM128,224h0L32,128,128,32,224,128Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), a("g", y, l[5] || (l[5] = [
        e("path", { d: "M232.5,119.55,136.45,23.49a12,12,0,0,0-16.9,0l-96,96.06a12,12,0,0,0,0,16.9l96.05,96.06a12,12,0,0,0,16.9,0l96.05-96.06a12,12,0,0,0,0-16.9Zm-5.66,11.24-96.05,96.06a4,4,0,0,1-5.58,0l-96-96.06a3.94,3.94,0,0,1,0-5.58l96.05-96.06a4,4,0,0,1,5.58,0l96.05,96.06a3.94,3.94,0,0,1,0,5.58Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  v as default
};
